import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { CustomConnectionsRoute } from '../../routing'

export class CustomConnectionsPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <CustomConnectionsRoute />
            </Fragment>
        )
    }
}
